module.exports = __webpack_public_path__ + "img/3.6ef2ee96.png";